module.exports = __webpack_public_path__ + "fonts/Flaticon2.378c03df.woff2";